import { parseScaled } from '../ui/numbers';

/** The one place where złoty typed by a person become grosze (integers) and back. */

/** "1 234,5" -> 123450. Accepts a comma or a dot, spaces, a trailing "zł"; at most two decimals. Throws on anything else. */
export function parsePln(text: string): number {
  const grosze = parseScaled(text.replace(/\s*zł\s*$/i, ''), 2, { maxIntegerDigits: 9 });
  if (grosze === null) throw new Error('Podaj kwotę w złotych, np. 1 234,50');
  return grosze;
}

/** 123450 -> "1 234,50 zł" (grouped by hand: pl-PL in Intl leaves four-digit numbers ungrouped). */
export function formatPln(grosze: number): string {
  // F29: results and margins can be below zero
  if (grosze < 0) return `−${formatPln(-grosze)}`;
  const zl = String(Math.floor(grosze / 100)).replace(/\B(?=(\d{3})+$)/g, '\u00a0');
  return `${zl},${String(grosze % 100).padStart(2, '0')}\u00a0zł`;
}

/** 123450 -> "1234,50": the value put into a form field. */
export function plnToInput(grosze: number): string {
  const zl = Math.floor(grosze / 100);
  const gr = String(grosze % 100).padStart(2, '0');
  return `${zl},${gr}`;
}
